export const ThemesColors = {
  Red_100: '#FFF5F2',
  Red_200: '#FFC2B5',
  Red_300: '#FB8777',
  Red_400: '#F3453A',
  Red_500: '#E30000',
  Red_600: '#B40000',
  Red_700: '#850000',
  Red_800: '#550000',
  Red_900: '#260000',
  HotPink_100: '#FFF2F7',
  HotPink_200: '#FFC2DE',
  HotPink_300: '#FF93CB',
  HotPink_400: '#FF63BD',
  HotPink_500: '#FF5197',
  HotPink_600: '#C91190',
  HotPink_700: '#93046F',
  HotPink_800: '#5C004B',
  HotPink_900: '#260021',
  Error_100: '#FFF5F2',
  Error_200: '#FFD3C9',
  Error_300: '#FF8078',
  Error_400: '#FF8078',
  Error_500: '#FF4F4F',
  Error_600: '#C92727',
  Error_700: '#931414',
  Error_800: '#5C0A0A',
  Error_900: '#260404',
  Salmon_100: '#FFF8F2',
  Salmon_200: '#FFE1D1',
  Salmon_300: '#FDC6AF',
  Salmon_400: '#FAA68C',
  Salmon_500: '#F28168',
  Salmon_600: '#BF4D3C',
  Salmon_700: '#8C2B24',
  Salmon_800: '#591515',
  Salmon_900: '#260909',
  Orange_100: '#FFFBF2',
  Orange_200: '#FFE4B6',
  Orange_300: '#FDC47A',
  Orange_400: '#FA9D3D',
  Orange_500: '#F26E02',
  Orange_600: '#BF4B01',
  Orange_700: '#8C2F00',
  Orange_800: '#591900',
  Orange_900: '#260800',
  Yellow_100: '#FFFFF2',
  Yellow_200: '#FFFCB6',
  Yellow_300: '#FFF279',
  Yellow_400: '#FFE03D',
  Yellow_500: '#FFCC00',
  Yellow_600: '#C99200',
  Yellow_700: '#936200',
  Yellow_800: '#5C3800',
  Yellow_900: '#261500',
  DustyBrown_100: '#F6F6F0',
  DustyBrown_200: '#FAF3DD',
  DustyBrown_300: '#EBDDBB',
  DustyBrown_400: '#D1BC97',
  DustyBrown_500: '#937C5D',
  DustyBrown_600: '#715536',
  DustyBrown_700: '#573D25',
  DustyBrown_800: '#3A2517',
  DustyBrown_900: '#231610',
  Success_100: '#F2FFF8',
  Success_200: '#COFED7',
  Success_300: '#8BF6AD',
  Success_400: '#53E078',
  Success_500: '#21B53E',
  Success_600: '#0B911E',
  Success_700: '#026E0B',
  Success_800: '#004A02',
  Success_900: '#012600',
  WashedGreen_100: '#F2FFFF',
  WashedGreen_200: '#C6FDEB',
  WashedGreen_300: '#92EECB',
  WashedGreen_400: '#58C595',
  WashedGreen_500: '#21754B',
  WashedGreen_600: '#106234',
  WashedGreen_700: '#084E23',
  WashedGreen_800: '#053A16',
  WashedGreen_900: '#03260C',
  Teal_100: '#F2FEFF',
  Teal_200: '#B6FBFF',
  Teal_300: '#79FFFF',
  Teal_400: '#3DFFF4',
  Teal_500: '#00FFE1',
  Teal_600: '#00C9A6',
  Teal_700: '#009370',
  Teal_800: '#005C41',
  Teal_900: '#00402A',
  Blue_100: '#F2F3FF',
  Blue_200: '#BFC7FF',
  Blue_300: '#8CA1FF',
  Blue_400: '#5981FF',
  Blue_500: '#2667FF',
  Blue_600: '#0D50C9',
  Blue_700: '#033F93',
  Blue_800: '#002C5C',
  Blue_900: '#001426',
  Purple_100: '#FCF2FF',
  Purple_200: '#EABFFE',
  Purple_300: '#CD89F7',
  Purple_400: '#A351E3',
  Purple_500: '#6D1EBD',
  Purple_600: '#480A97',
  Purple_700: '#2D0271',
  Purple_800: '#19004C',
  Purple_900: '#0A0026',
  Neutrals_000: '#FFFFFF',
  Neutrals_100: '#FAFAFA',
  Neutrals_200: '#EDEDED',
  Neutrals_300: '#E0E0E0',
  Neutrals_400: '#D8D8D8',
  Neutrals_500: '#B5B5B5',
  Neutrals_600: '#848484',
  Neutrals_700: '#616161',
  Neutrals_800: '#2F2F2F',
  Neutrals_900: '#222222',
  Neutrals_1000: '#000000',
  Overlays_700: '#00000070',
  Overlays_200: '#00000020'
}
